import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicSizeIcon from "../DynamicSizeIcon";
import { useGlobalData } from "@/contexts/GlobalData";
import DynamicFontSize from "../DynamicFontSize";
interface WarningGroupPropsType extends GeneralPropsType {
  icon?: string;
}
function WarningGroup({
  children,
  className
}: WarningGroupPropsType) {
  const {
    getIcon
  } = useGlobalData();
  return <div className={clsx("flex items-center gap-2", styles.container, styles.message, className)} data-sentry-component="WarningGroup" data-sentry-source-file="index.tsx">
            <DynamicSizeIcon icon={getIcon("red_tooltip")} width={18} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
            <DynamicFontSize fontSize={14} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">{children}</DynamicFontSize>
        </div>;
}
export default WarningGroup;